<template>
    <Series :id="id"/>
</template>
<script>
import Series from '@/components/Series.vue';

export default {
    name: 'SeriesAdd',
    components: {
        Series
    },
    data() {
        return {
            id: null,
        }   
    },
    mounted() {
        this.id = this.$route.params.id ? +this.$route.params.id : null;
    },
}
</script>
